// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30BqG","right":"styles_right__SM2PJ"};